import PromoCodePage from './ducks/PromoCodePage.duck';
import promoCode from './ducks/promoCode.duck';
import applyPromoCodeReducers from './ducks/applyPromoCode.duck';
import EditPromoCodePage from './ducks/EditPromoCodePage.duck';
import fieldSelectListings from './ducks/fieldSelectListings.duck';

export default {
  PromoCodePage,
  promoCode,
  applyPromoCode: applyPromoCodeReducers,
  EditPromoCodePage,
  fieldSelectListings,
};
